import { ApiUrl, ApiUrlAdmin } from "./common/Config";
import { postAdmin,post , getAdmin,get} from "./common/Helper";

export const getReports = async (params, token) => {
  let url = ApiUrlAdmin + "report";
  return await postAdmin(url, params, token, true);
};

export const updateReport = async (id, reportContentType, token) => {
  let url = ApiUrlAdmin + "report/update";
  return await postAdmin(url, { Id: id, ReportContentType: reportContentType }, token, true);
};

export const getReportsDetails = async (BookSectionCropId, token) => {
  let url = ApiUrlAdmin + "report/details";
  return await postAdmin(url, { BookSectionCropId }, token, true);
};
export const updateAnswer = async (data, token) => {
  let url = ApiUrlAdmin + "report/update-answer";
  return await postAdmin(url, data, token, true);
};
export const updateCropAnswer = async (data, token) => {
  let url = ApiUrl + "report/update-crop-answer";
  return await postAdmin(url, data, token, true);
};
export const getImageUrlR = async (data, token) => {
  let url = ApiUrl + "booksectioncrop/getcroppedimage";
  return await post(url, data, token);
};
export const getImageUrlRProd = async (data, token) => {
  let url = ApiUrlAdmin + "booksectioncrop/getcroppedimage";
  return await post(url, data, token);
};
export const cropPage = async (BookSectionCropId, token) => {
  let url = ApiUrl + "report/cropPage";
  return await postAdmin(url, {BookSectionCropId}, token, true);
};

export const getAchievementVideoReports = async (params, token) => {
  let url = ApiUrlAdmin + "report/achievementvideo";
  return await postAdmin(url, params, token, true);
};

export const getAchievementVideoDetail = async (achievementVideoId, token) => {
  let url = ApiUrlAdmin + `report/achievementvideo/detail?achievementVideoId=${achievementVideoId}`;
  return await getAdmin(url, token);
};

// LectureSection (ReportContentType = 4)
export const getLectureSectionReports = async (params, token) => {
  let url = ApiUrlAdmin + "report/lecturesection";
  return await postAdmin(url, params, token, true);
};

export const getLectureSectionDetail = async (lectureSectionId, token) => {
  let url = ApiUrlAdmin + `report/lecturesection/detail?lectureSectionId=${lectureSectionId}`;
  return await getAdmin(url, token);
};

export const removeContent = async (id, reportContentType, token) => {
  let url = ApiUrlAdmin + "book/remove";
  return await postAdmin(url, { Id: id, ReportContentType: reportContentType }, token, true);
};
export const getAchievementVideoReactions = async (params, token) => {
  console.log("params, token",{params, token});
  let url = ApiUrl + "report/videoreaction";
  return await post(url, params, token);
};

export const getAchievementVideoReactionDetail = async (achievementVideoId, token) => {
  let url = ApiUrl + "report/videodetails";
  return await post(url, { AchievementVideoId: achievementVideoId }, token);
};
